module.exports = __webpack_public_path__ + "static/media/logo_geochicas_black_medium@2x.db91f303.jpg";